







import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ModuleLayout extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/newprogram/components/modulelayout/ModuleLayout.vue